import { MessageItem } from './../models/Item';
import { stringify } from 'querystring';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DbmanagerService } from '../services/dbmanager.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MessDialogComponent } from '../shared/mess-dialog/mess-dialog.component';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit, OnDestroy {

  userMessages: Map<string, MessageItem> ;
  messageSubscriber;

  constructor(private dbservice: DbmanagerService, private dialog: MatDialog) {
    this.userMessages = new Map<string, MessageItem>();
  }

  ngOnInit(): void {
    this.messageSubscriber = this.dbservice.getMessages().subscribe(messages => {
      messages.forEach(mess => {
        if (!mess.CONFIRMED) {
          this.userMessages.set(mess.KEY, mess);
        } else if (this.userMessages.has(mess.KEY)) {
          this.userMessages.delete(mess.KEY);
        }
      });
    });
  }

  ngOnDestroy() {
    this.messageSubscriber.unsubscribe();
  }

  showMessage(message) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      id: 1,
      content: message.CONTENT
    };
    const dataDialogRef = this.dialog.open(MessDialogComponent, dialogConfig).afterClosed().subscribe(data => {
      if (data !== undefined) {
        this.dbservice.confirmMessage(message.KEY);
        }
      }
    );
  }

  messages(): Map<string, MessageItem> {
    return this.userMessages;
  }
}

class Message {
  constructor(public data: string, public type: string) { }
}

